
























































import Vue from "vue";
import country_codes from "@/assets/country_codes.json";
import { phoneLast4FromE164 } from "@/utils/twoFactor/twoFactor";

// Strip spaces, then a loose E.164 check (mirrors the backend contract).
const E164_PATTERN = /^\+?[1-9]\d{6,14}$/;

export default Vue.extend({
  name: "TwoFactorPhoneCaptureV2",
  data() {
    return {
      countryCode: "+353",
      mobile: "",
      countryCodes: [] as typeof country_codes,
      isSending: false,
    };
  },
  mounted() {
    // Surface the most common markets first; the rest keep the JSON's order.
    const priorityCodes = ["IE", "GB", "AU", "NZ"];
    const prioritised = priorityCodes
      .map((code) => country_codes.find((item) => item.code === code))
      .filter(Boolean) as typeof country_codes;
    const remainder = country_codes.filter(
      (item) => !priorityCodes.includes(item.code),
    );
    this.countryCodes = [...prioritised, ...remainder];
  },
  computed: {
    fullPhone(): string {
      return `${this.countryCode}${this.mobile}`.replace(/\s/g, "");
    },
    isValidPhone(): boolean {
      return E164_PATTERN.test(this.fullPhone);
    },
  },
  methods: {
    async leaveTwoFactor(): Promise<void> {
      await this.$store.dispatch("clearTwoFactorChallenge");
      await this.$store.dispatch("acceptWarning");
      this.$emit("sign-in");
      await this.$router.replace("/login").catch(() => undefined);
    },
    restrictToDigits(evt: KeyboardEvent): void {
      if (isNaN(Number(evt.key)) && evt.key !== "Backspace") {
        evt.preventDefault();
      }
      if (evt.key !== "Backspace" && this.mobile.length > 11) {
        evt.preventDefault();
      }
    },
    async submitForm(): Promise<void> {
      if (!this.isValidPhone || this.isSending) return;
      this.isSending = true;
      try {
        // The oath_token from the phone_required response — used only here.
        const temporaryToken = await this.$store.dispatch("twoFactorSend", {
          token: this.$route.query.oauth,
          phone: this.fullPhone,
        });
        if (temporaryToken) {
          const oauthQuery = this.$route.query.oauth;
          await this.$store.dispatch("setTwoFactorChallenge", {
            temporaryToken,
            oathToken: typeof oauthQuery === "string" ? oauthQuery : "",
            phone: this.fullPhone,
            phoneLast4: phoneLast4FromE164(this.fullPhone),
            skipInitialCooldown: false,
            initialError: "",
          });
          this.$router.push("/two-factor?oauth=" + temporaryToken);
        }
      } finally {
        this.isSending = false;
      }
    },
  },
});
